import { Component, OnInit, ViewChild } from '@angular/core';
import { Observable } from 'rxjs';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-afiliados',
  templateUrl: './afiliados.component.html',
  styleUrls: ['./afiliados.component.scss']
})
export class AfiliadosComponent implements OnInit {  

  ngOnInit(): void {
  }
  @ViewChild('cuota',{static: true})cuota: NgForm;

  jubilacionminima: any;
  descuentoFijo: any;
  excedente: any;
  cincoSobreExcedente: any;
  TotalAporteTitular: any;
  seguro: any;
  seguroFesac: any;
  valorConyuge: any;
  Resultado: any

  

  id: any;
  
  constructor() {         

    this.jubilacionminima = 403317.99; //Junio 2026
    this.descuentoFijo = 0;
    this.excedente = 0;
    this.cincoSobreExcedente = 0;
    this.TotalAporteTitular = 0;
    this.seguro = 1000;
    this.seguroFesac = 23581.79; //Junio 2026
    this.valorConyuge = 0;
    this.Resultado =0;    
     
  }


  calculoCuota(){
    
    let haberJubilatorio = Number(this.cuota.value.haberJubilatorio);
    let conyuge = String(this.cuota.value.conyuge);

    this.descuentoFijo = this.jubilacionminima*(7/100);
    this.excedente = haberJubilatorio - this.jubilacionminima;
    this.cincoSobreExcedente = this.excedente*(5/100);
    this.TotalAporteTitular = this.descuentoFijo + this.cincoSobreExcedente;
    this.TotalAporteTitular = this.TotalAporteTitular*(1.10); //Se le suma el 10%
    if(conyuge == "si"){
      this.valorConyuge = this.TotalAporteTitular;
    }
    
    this.Resultado = (this.TotalAporteTitular + this.valorConyuge + this.seguro + this.seguroFesac);
    this.Resultado = this.Resultado.toFixed(2);

    this.reinicio();

    return this.Resultado;     
         
    //this.cuota.reinicio();
    
  }
  reinicio(){
    this.descuentoFijo = 0;
    this.excedente = 0;
    this.cincoSobreExcedente = 0;
    this.TotalAporteTitular = 0;
    this.seguro = 1000;
    this.seguroFesac = 23581.79;
    this.valorConyuge = 0;
     
  }

}
